import { render, staticRenderFns } from "./areaPrice.vue?vue&type=template&id=033de030&scoped=true&"
import script from "./areaPrice.vue?vue&type=script&lang=js&"
export * from "./areaPrice.vue?vue&type=script&lang=js&"
import style0 from "./areaPrice.vue?vue&type=style&index=0&id=033de030&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033de030",
  null
  
)

export default component.exports